import React from "react";
import "./Filter_btn.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Filter_btn({ btnText, icon, onClick }) {
  return (
    <>
      <section className="Filter_btn_holder">
        <Button className="Filter_btn" onClick={onClick} ><FontAwesomeIcon className="btn_icon" icon={icon} /> {btnText}</Button>
      </section>
    </>
  );
}

export default Filter_btn;
